import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { styled, LinearProgress, linearProgressClasses, Box, useTheme, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import MessageCard from '../../Components/Card/MessageCard.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';
import { sumAllItemQuantities } from '../../utils/checkout.js';
import pluralize from 'pluralize';
import { brandclubStyles } from '../../styles/index.js';
import '../../Components/Animation/AnimationDot.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/ChatIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from '../../Components/Button/Button.js';
import { CloseButton } from '../../Components/Button/CloseButton.js';
import '../../Components/Button/CustomDtcBagButton.js';
import '../../Components/BuyBoxDialog/BuyBoxType.js';
import '../../Components/BuyBoxDialog/PriceDialogContent.js';
import '../../Components/BuyBoxDialog/ProductPrice.js';
import '../../Components/ImageCropper/ImageCropper.js';
import 'immer';
import '../../Components/automated-theme-setup/DraggableThemeFab.js';
import '@mui/icons-material/ExpandMore';
import '@mui/icons-material/Palette';
import '@mui/icons-material/TextFields';
import '@mui/icons-material/Settings';
import '@mui/icons-material/Notes';
import '@mui/icons-material/SmartButton';
import '@mui/material/styles';
import '../../Components/automated-theme-setup/CustomColorPicker.js';
import { createResponsiveStyles } from '../../theme/util.js';
import '@mui/material/CircularProgress';
import 'react-lottie';
import '../../Components/automated-theme-setup/ThemeElementSelector.js';
import '../../Components/Dialog/ResponsiveDialog.js';
import { CartProduct } from './CartProduct.js';
import '../../theme/customTheme.js';
import '../../theme/defaultTheme.js';
import { DTCComponentName, ButtonName } from '../../theme/componentNames.js';
import 'lodash';

// SharedCheckoutDrawer.tsx
const StyledMesssageCard = styled(MessageCard)(({ theme }) => {
    var _a;
    return (Object.assign(Object.assign({ color: theme.vars.palette.text.primary }, createResponsiveStyles(theme, (_a = theme.componentCSSOverrides) === null || _a === void 0 ? void 0 : _a[DTCComponentName.EmptyBagMessageCard])), { '.store-message-card__cta': {
            backgroundColor: theme.vars.palette.primary.main,
            color: theme.vars.palette.primary.contrastText,
        } }));
});
const EmptyBagMessageCard = ({ onActionClick }) => {
    var _a, _b;
    const theme = useTheme();
    const customHeaderText = (_b = (_a = theme.globalComponentPresets) === null || _a === void 0 ? void 0 : _a.checkoutDrawer) === null || _b === void 0 ? void 0 : _b.customEmptyBagMessageCardHeaderText;
    return (React.createElement(Box, { sx: { padding: '20px' } },
        React.createElement(StyledMesssageCard, { title: customHeaderText || 'Your bag is empty.', content: "Can we make some suggestions to help get you started?", cta: "Shop popular products", onActionClick: onActionClick })));
};
const getTotal = (products) => {
    return products.reduce((acc, item) => {
        return acc + item.retailPrice * item.quantity;
    }, 0);
};
const calculateTotalOfAllCarts = (carts) => {
    const total = carts.reduce((acc, cart) => {
        var _a;
        return acc + getTotal((_a = cart.items) !== null && _a !== void 0 ? _a : []);
    }, 0);
    return formatMoney(total);
};
const CheckoutContainer = styled('div', {
    label: 'CheckoutContainer',
})(({ theme }) => {
    var _a, _b, _c, _d;
    return ({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: theme.vars.palette.background.paper,
        width: 462,
        maxWidth: '100vw',
        color: theme.vars.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '.bc_header_section': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '23px 28px 10px 28px',
            [theme.breakpoints.down('sm')]: {
                padding: '23px 5% 10px 5%',
            },
            '.bc_header': {
                fontSize: 20,
                fontWeight: 700,
            },
            '.sub_header': {
                fontSize: 18,
                fontWeight: 600,
            },
        },
        '.product_section': Object.assign(Object.assign({ flex: 1, overflowY: 'scroll' }, brandclubStyles.customScrollbar), { padding: '23px 27px', '.cart_product + .cart_product': {
                borderTop: `1px solid #dcdcdc`,
            }, [theme.breakpoints.down('sm')]: {
                padding: '23px 5%',
            }, '.cart_group': {
                marginBottom: 50,
                [theme.breakpoints.down('sm')]: {
                    marginBottom: 30,
                },
            }, '.group_info': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 8,
                marginBottom: 10,
                [theme.breakpoints.down('sm')]: {
                    marginTop: 10,
                    marginBottom: 14,
                },
                '.group_count': {
                    fontSize: 14,
                    fontWeight: 500,
                },
                '.group_subtotal': {
                    fontSize: 14,
                    fontWeight: 500,
                    '.bc-dtc-price, .price': {
                        fontWeight: 600,
                    },
                },
            } }),
        '.checkout_section': {
            display: 'flex',
            flexDirection: 'column',
            gap: '23px',
            padding: '23px 27px 37px 27px',
            boxShadow: '0 0 6px 0 rgba(119, 115, 115, 0.16)',
            [theme.breakpoints.down('sm')]: {
                padding: ((_b = (_a = theme.globalComponentPresets) === null || _a === void 0 ? void 0 : _a.checkoutDrawer) === null || _b === void 0 ? void 0 : _b.checkoutDrawerHeaderButton)
                    ? '23px 5% 23px 5%'
                    : '23px 5% 37px 5%',
                boxShadow: ((_d = (_c = theme.globalComponentPresets) === null || _c === void 0 ? void 0 : _c.checkoutDrawer) === null || _d === void 0 ? void 0 : _d.checkoutDrawerHeaderButton)
                    ? `0 4px 6px -2px rgba(119, 115, 115, 0.16)`
                    : '0 0 6px 0 rgba(119, 115, 115, 0.16)',
            },
            '.subtotal': {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                fontSize: 18,
                fontWeight: 600,
                color: theme.vars.palette.text.primary,
            },
        },
    });
});
const StyledEmptyBagMessageCard = styled(EmptyBagMessageCard)({
    width: 'auto',
    margin: '0 25px',
    marginTop: 50,
    '.store-message-card__content': {
        fontSize: 16,
        width: 282,
    },
    '.store-message-card__title': {
        fontSize: 20,
    },
    '.store-message-card__cta': {
        marginTop: 10,
    },
});
const getAllSortedProducts = (cartItems, allCarts) => {
    const allItems = allCarts.flatMap((cart) => cart.items);
    const sortedProducts = allItems.sort((a, b) => {
        var _a, _b;
        const aCreatedTime = (_a = cartItems.find((item) => item.retailerSku === a.retailerSku)) === null || _a === void 0 ? void 0 : _a.createdTime;
        const bCreatedTime = (_b = cartItems.find((item) => item.retailerSku === b.retailerSku)) === null || _b === void 0 ? void 0 : _b.createdTime;
        // If both have no createdTime, maintain original order
        if (!aCreatedTime && !bCreatedTime)
            return 0;
        // If only a has no createdTime, a comes first (negative value)
        if (!aCreatedTime)
            return -1;
        // If only b has no createdTime, b comes first (positive value)
        if (!bCreatedTime)
            return 1;
        // Both have createdTime, sort by newest first
        return bCreatedTime - aCreatedTime;
    });
    return sortedProducts;
};
const ProductSection = ({ loading, allCarts, cartItems, LoadingComponent, storeBrandingType, cartProducts, handleAddQuantity, handleMinusQuantity, }) => {
    if (loading) {
        return React.createElement(Box, { className: "product_section" }, LoadingComponent ? React.createElement(LoadingComponent, null) : React.createElement("div", null, "Loading..."));
    }
    if (!allCarts || allCarts.length === 0) {
        return null;
    }
    const sortedProducts = getAllSortedProducts(cartItems, allCarts);
    return (React.createElement(Box, { className: "product_section" },
        React.createElement(Box, { className: "group_info" },
            React.createElement(Box, { className: "group_count" }, pluralize('item', sumAllItemQuantities(allCarts), true)),
            React.createElement(Box, { className: "group_subtotal" },
                "Subtotal: ",
                React.createElement("span", { className: "bc-dtc-price" }, calculateTotalOfAllCarts(allCarts)))),
        sortedProducts.map((product) => (React.createElement(CartProduct, { key: `product:${product.stacklineSku}`, product: product, cartProducts: cartProducts, storeBrandingType: storeBrandingType, handleAddQuantity: handleAddQuantity, handleMinusQuantity: handleMinusQuantity })))));
};
const CheckoutSection = ({ initiating, closeDrawer, canCheckout, allCarts = [], onCheckout, onViewBag, closeAfterCheckout = true, }) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    const customCheckoutText = (_b = (_a = theme.globalComponentPresets) === null || _a === void 0 ? void 0 : _a.checkoutDrawer) === null || _b === void 0 ? void 0 : _b.customCheckoutText;
    const customViewBagText = (_d = (_c = theme.globalComponentPresets) === null || _c === void 0 ? void 0 : _c.checkoutDrawer) === null || _d === void 0 ? void 0 : _d.customViewBagText;
    const [localInitiating, setLocalInitiating] = useState(false);
    const handleCheckout = () => __awaiter(void 0, void 0, void 0, function* () {
        if (allCarts.length > 0) {
            try {
                setLocalInitiating(true);
                yield onCheckout(allCarts);
            }
            finally {
                if (closeAfterCheckout) {
                    closeDrawer();
                }
            }
        }
    });
    return (React.createElement(Box, { className: "checkout_section" },
        React.createElement(Box, { display: "flex", gap: "12px", width: "100%", flexDirection: "column", alignItems: "center" },
            canCheckout ? (React.createElement(Button, { className: "bc-checkout-drawer-checkout-button", increaseSpecificity: true, variant: "solid", color: "primary", fullWidth: true, buttonName: ButtonName.BagDrawerCheckoutButton, disabled: initiating || localInitiating, onClick: handleCheckout, disableMaxWidth: true, sx: {
                    width: '100%',
                } }, customCheckoutText || 'Checkout')) : null,
            React.createElement(Button, { className: "bc-checkout-drawer-view-bag-button", increaseSpecificity: true, fullWidth: true, variant: "outline", color: "primary", buttonName: ButtonName.BagDrawerViewBagButton, onClick: onViewBag, disableMaxWidth: true, sx: {
                    width: '100%',
                } }, customViewBagText || 'View bag'))));
};
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.vars.palette.primary.main,
    },
}));
const StyledFreeShippingCap = styled(Box)(({ theme }) => ({
    color: theme.vars.palette.text.primary,
    padding: '23px 27px 0 27px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
        padding: '23px 5%',
    },
    '.free-shipping-cap-text': {
        fontSize: 14,
        fontWeight: 500,
        marginBottom: 6,
    },
    '.free-shipping-text': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 500,
        color: theme.vars.palette.text.primary,
    },
}));
const FreeShippingOffer = ({ allCarts, freeShippingCap, }) => {
    const total = (allCarts === null || allCarts === void 0 ? void 0 : allCarts.reduce((acc, cart) => {
        var _a;
        return acc + getTotal((_a = cart.items) !== null && _a !== void 0 ? _a : []);
    }, 0)) || 0;
    const isFreeShipping = total >= freeShippingCap;
    const remainingAmount = freeShippingCap - total;
    if (total === 0) {
        return null;
    }
    if (isFreeShipping) {
        return (React.createElement(StyledFreeShippingCap, null,
            React.createElement(Box, { className: "free-shipping-cap-text" }, "You're getting Free Standard Shipping!")));
    }
    return (React.createElement(StyledFreeShippingCap, null,
        React.createElement(Box, { className: "free-shipping-cap-text" },
            "You're ",
            formatMoney(remainingAmount),
            " away from Free Standard Shipping"),
        React.createElement(BorderLinearProgress, { variant: "determinate", value: (total / freeShippingCap) * 100 }),
        React.createElement(Box, { className: "free-shipping-text" },
            React.createElement("div", null, formatMoney(0)),
            React.createElement("div", null, formatMoney(freeShippingCap)))));
};
const CheckoutDrawer = ({ loading, cartItems, showFreeShippingOffer = false, allCarts, storeBrandingType, cartProducts, handleAddQuantity, handleMinusQuantity, closeDrawer, onCheckout, onViewBag, onEmptyBagAction, LoadingComponent, initiating = false, closeAfterCheckout = true, }) => {
    var _a, _b, _c, _d;
    const hasItems = allCarts && allCarts.length > 0;
    const retailerWithItems = allCarts === null || allCarts === void 0 ? void 0 : allCarts.filter((cart) => cart.items.length > 0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const checkoutDrawerHeaderButton = (_b = (_a = theme.globalComponentPresets) === null || _a === void 0 ? void 0 : _a.checkoutDrawer) === null || _b === void 0 ? void 0 : _b.checkoutDrawerHeaderButton;
    const customHeaderName = (_d = (_c = theme.globalComponentPresets) === null || _c === void 0 ? void 0 : _c.checkoutDrawer) === null || _d === void 0 ? void 0 : _d.customHeaderName;
    return (React.createElement(CheckoutContainer, { className: "bc-checkout-drawer" },
        React.createElement(Box, { className: "bc_header_section" },
            React.createElement(Box, { className: "bc_header" }, customHeaderName || 'Bag'),
            React.createElement(CloseButton, { style: {
                    all: 'unset',
                    cursor: 'pointer',
                }, className: "options", onClick: closeDrawer, iconSize: 15 })),
        showFreeShippingOffer ? React.createElement(FreeShippingOffer, { allCarts: allCarts, freeShippingCap: 35 }) : null,
        !hasItems && !loading ? (React.createElement(StyledEmptyBagMessageCard, { onActionClick: onEmptyBagAction || closeDrawer })) : (React.createElement(React.Fragment, null,
            hasItems && checkoutDrawerHeaderButton && isMobile ? (React.createElement(CheckoutSection, { canCheckout: (retailerWithItems === null || retailerWithItems === void 0 ? void 0 : retailerWithItems.length) === 1, initiating: initiating, allCarts: allCarts, closeDrawer: closeDrawer, onCheckout: onCheckout, onViewBag: onViewBag, closeAfterCheckout: closeAfterCheckout })) : null,
            React.createElement(ProductSection, { storeBrandingType: storeBrandingType, cartProducts: cartProducts, handleAddQuantity: handleAddQuantity, handleMinusQuantity: handleMinusQuantity, loading: loading, allCarts: allCarts, cartItems: cartItems, LoadingComponent: LoadingComponent }),
            hasItems && !(checkoutDrawerHeaderButton && isMobile) && (React.createElement(CheckoutSection, { canCheckout: (retailerWithItems === null || retailerWithItems === void 0 ? void 0 : retailerWithItems.length) === 1, initiating: initiating, allCarts: allCarts, closeDrawer: closeDrawer, onCheckout: onCheckout, onViewBag: onViewBag, closeAfterCheckout: closeAfterCheckout }))))));
};

export { CheckoutDrawer, calculateTotalOfAllCarts, CheckoutDrawer as default };
//# sourceMappingURL=CheckoutDrawer.js.map
